var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_vm._t("default",function(){return [_c('div',{staticClass:"margin-bottom-large"},[_c('h2',{staticClass:"text-h2"},[_vm._v(" Table & Map ")]),_c('h6',{staticClass:"text-h6 tagline"},[_vm._v(" "+_vm._s(_vm.tagline)+" ")])])]}),_c('UploadWorkflow',{on:{"finish":_vm.finish}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }